import React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import {connect} from 'react-redux';
import SignInPage from './pages/Authorization/SignIn';
import NotFound from './pages/Page404';
import PrivateRoute from 'components/PrivateRoute';
import Users from './pages/Organizations';
import FbAccounts from './pages/FbAccounts';
import Products from './pages/Products';
import NudgeEmails from './pages/NudgeEmails';

// import GlobalSources from './pages/GlobalSources/index';
import CombinedUsers from './pages/CombinedUsers/index';
import Status from './pages/Status';

const Routes = ({auth}) => {
    return (
        <Switch>
            {/*<Route*/}
            {/*    exact*/}
            {/*    path="/"*/}
            {/*    >*/}
            {/*    <Redirect to="/users"/>*/}
            {/*</Route>*/}


            <Route
                exact
                path="/"
                render={() =>
                    auth.isAuthenticated ?
                        <Redirect to="/organizations"/>
                        :
                        <PrivateRoute canEnter={false} exact path="/" component={SignInPage} />
                }
            />



            <PrivateRoute canEnter={true} path="/organizations" component={Users} />
            <PrivateRoute canEnter={true} path="/fb-accounts" component={FbAccounts} />
            <PrivateRoute canEnter={true} path="/combined-users" component={CombinedUsers} />
            <PrivateRoute canEnter={true} path="/products" component={Products} />
            <PrivateRoute canEnter={true} path="/nudge-emails" component={NudgeEmails} />
            {/*<PrivateRoute canEnter={true} path="/global_sources" component={GlobalSources} />*/}
            {/*<PrivateRoute canEnter={false} exact path="/" component={SignInPage} />*/}
            <Route path="/status">
                <Status />
            </Route>
            <Route path="/home">
                <Redirect to="/" />
            </Route>
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(Routes);